<div class="pdf-preview">
  <div class="pdf-preview__head">
    <h2 class="pdf-preview__title">
      <mat-icon aria-hidden="true">picture_as_pdf</mat-icon>
      {{ title }}
    </h2>
    <button mat-icon-button (click)="close()" aria-label="Close preview">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="pdf-preview__body">
    <iframe
      [src]="safeUrl"
      class="pdf-preview__frame"
      [title]="title"></iframe>
  </div>

  <div class="pdf-preview__actions" mat-dialog-actions>
    <button mat-stroked-button (click)="close()">Close</button>
    <button mat-flat-button color="primary" (click)="download()">
      <mat-icon aria-hidden="true">download</mat-icon>
      Download
    </button>
  </div>
</div>
